import httpReq from '@/server/http'

const httpRequest = {

  // **************************基础参数配置 start****************
  getBasicsCustom: function (params) {
    var url = '/api/config/custom-field';

    return httpReq(url, 'GET', params);
  },
  // 获取七牛token
  reqQiNiuToken: function (params) {
    var url = '/api/qiniu/token';

    return httpReq(url, 'GET', params);
  },
  // start-up
  reqStartUpInfo: function (params) {
    var url = '/api/app/system/start-up';

    return httpReq(url, 'GET', params);
  },
  // **************************基础参数配置 end****************


  // **************************登录 start****************
  // 获取兑换课程、登录验证码
  getLoginVerifyCode: function (params) {
    var url = '/api/app/auth/send-verify-code';

    return httpReq(url, 'POST', params);
  },

  // 兑换课程接口
  exchangeCourse: function (params) {
    var url = '/api/course/redeem/exchange';

    return httpReq(url, 'POST', params);
  },

  // 登陆后兑换课程接口
  exchangeCourseAfterLogin: function (params) {
    var url = '/api/course/redeem/exchange-online';

    return httpReq(url, 'POST', params);
  },

  // 课程兑换记录
  courseExchangeRecord: function () {
    var url = '/api/course/redeem/record';

    return httpReq(url, 'GET');
  },


  // 登录接口
  userLogin: function (params) {
    var url = '/api/app/auth/token';

    return httpReq(url, 'POST', params);
  },

  // 获取用户信息
  getUserInfo: function () {
    var url = '/api/app/auth/user';

    return httpReq(url, 'GET');
  },

  // 检查手机号是否注册
  checkPhoneIsRegister: function (params) {
    var url = '/api/app/auth/check-form';

    return httpReq(url, 'GET', params);
  },

  // 三方登录接口
  thirdLogin: function (params) {
    var url = '/api/app/auth/socialite-login';

    return httpReq(url, 'POST', params);
  },

  // 绑定三方接口
  bindThird: function (params) {
    var url = '/api/app/auth/user/socialite-bind';

    return httpReq(url, 'POST', params);
  },

  // 取消绑定三方接口
  cancelBindThird: function (params) {
    var url = '/api/app/auth/user/socialite-unbind';

    return httpReq(url, 'POST', params);
  },
  // **************************登录 start****************

  // ************************** 首页 start****************
  getMyCourseList: function (params) {
    var url = '/api/app/auth/user/course';

    return httpReq(url, 'GET', params);
  },

  getCourseSection: function (params) {
    var url = '/api/course/section';

    return httpReq(url, 'GET', params);
  },

  reqFirstCateDetail: function (params) {
    var url = '/api/course/system/detail';

    return httpReq(url, 'GET', params);
  },
  // **************************首页 end****************


  // ************************** 课程 start****************

  // 获取课程资源详情
  getCourseWork: function (params) {
    var url = '/api/course/section/resource/detail';

    return httpReq(url, 'GET', params);
  },

  // 提交答案记录
  submitCoureWordRecored: function (params) {
    var url = '/api/course/section/resource/question/answer';

    return httpReq(url, 'POST', params);
  },
  // 记录课程进度
  recordCourseSectionProgress: function (params) {
    var url = '/api/course/user-progress';

    return httpReq(url, 'POST', params);
  },
  // 知识点详情
  getHomeworkDetail: function (params) {
    var url = '/api/course/section/resource/detail/search';

    return httpReq(url, 'GET', params);
  },
  // 提交作业
  submitCourseWork: function (params) {
    var url = '/api/course/user-course-work';

    return httpReq(url, 'POST', params);
  },
  // 我的作业筛选列表
  getCourseSectionList: function (params) {
    var url = '/api/app/auth/user/course-work/select-systems';

    return httpReq(url, 'GET', params);
  },
  // 修改作业信息
  updateProductionInfo: function (params) {
    var url = '/api/course/user-course-work/update';

    return httpReq(url, 'POST', params);
  },
  // 我的错题
  getMyWrongbook: function (params) {
    var url = '/api/course/user-question-mistake';

    return httpReq(url, 'GET', params);
  },
  // 更新错题状态
  updateQuestionStatus: function (params) {
    var url = '/api/course/user-question-mistake/update';

    return httpReq(url, 'POST', params);
  },
  // **************************课程 end****************


  // ************************** 我的 start****************

  // 修改更新用户信息
  updateUserInfo: function (params) {
    var url = '/api/app/auth/user/update';

    return httpReq(url, 'POST', params);
  },
  // 头像修改
  uploadHeadImage: function (params) {
    var url = '/api/main/avatar';

    return httpReq(url, 'postfile', params.file);
  },
  // **************************我的 end****************

  // **************************课程 start***************
  getCourseSectionDetailInfo: function (params) {
    var url = '/api/course/section/detail';

    return httpReq(url, 'GET', params);
  },
  // **************************课程 end***************
}

export default httpRequest



// WEBPACK FOOTER //
// ./src/server/http-api.js